export enum Currencies {
  USD = 'USD',
  INR = 'INR',
}
